/* ============================================================
   Ross Alan Design - homepage interactions
   Loaded only when template == 'index' (see theme.liquid).
   ============================================================ */
(function () {
  function init() {
    // ============== HEADER SCROLL STATE ==============
    var header = document.getElementById('site-header');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 60) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // ============== MOBILE HAMBURGER MENU ==============
    var menuToggle = document.querySelector('.mobile-menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    var menuBackdrop = document.querySelector('.mobile-menu-backdrop');
    if (menuToggle && mobileMenu) {
      var closeMenu = function () {
        document.body.classList.remove('mobile-menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        menuToggle.setAttribute('aria-label', 'Open menu');
      };
      var openMenu = function () {
        document.body.classList.add('mobile-menu-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
        menuToggle.setAttribute('aria-label', 'Close menu');
      };
      menuToggle.addEventListener('click', function () {
        if (document.body.classList.contains('mobile-menu-open')) closeMenu();
        else openMenu();
      });
      if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && document.body.classList.contains('mobile-menu-open')) closeMenu();
      });
      // Submenu accordions
      mobileMenu.querySelectorAll('.m-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.nextElementSibling;
          if (!sub) return;
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (expanded) sub.setAttribute('hidden', ''); else sub.removeAttribute('hidden');
        });
      });
      // Close menu when any link inside is clicked (navigation intent)
      mobileMenu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeMenu);
      });
    }

    // ============== REVEAL ON SCROLL ==============
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    }

    // ============== CONSULTATION MODAL ==============
    var modal = document.getElementById('consultation-modal');
    var closeBtn = document.getElementById('modal-close-btn');
    var declineBtn = document.getElementById('modal-decline-btn');

    var MODAL_DISMISS_KEY = 'ra_modal_dismissed_at';
    var MODAL_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

    var recordDismiss = function () {
      try { localStorage.setItem(MODAL_DISMISS_KEY, String(Date.now())); } catch (e) {}
    };
    var wasRecentlyDismissed = function () {
      try {
        var t = parseInt(localStorage.getItem(MODAL_DISMISS_KEY) || '0', 10);
        return t && (Date.now() - t) < MODAL_COOLDOWN_MS;
      } catch (e) { return false; }
    };

    var closeModal = function () {
      if (!modal) return;
      modal.classList.remove('open');
      document.body.style.overflow = '';
      recordDismiss();
    };

    var openModal = function () {
      if (!modal) return;
      var formView = document.getElementById('modal-form-view');
      var successView = document.getElementById('modal-success');
      if (formView) formView.style.display = '';
      if (successView) successView.classList.remove('show');
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    };

    if (modal) {
      var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);
      if (!inThemeEditor && !wasRecentlyDismissed()) {
        setTimeout(openModal, 1500);
      }
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeModal(); });
      if (declineBtn) declineBtn.addEventListener('click', function (e) { e.preventDefault(); closeModal(); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
      });
    }

    // ============== WHATSAPP BUBBLE ==============
    var bubble = document.getElementById('whatsapp-bubble');
    if (bubble) {
      setTimeout(function () {
        bubble.classList.add('show');
        setTimeout(function () { bubble.classList.remove('show'); }, 5500);
      }, 6000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
